import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChange, ChangeDetectorRef } from '@angular/core';
import { PortalProductsService } from '../../../../services/portal-products.service';

@Component({
  selector: 'app-approval-progress',
  templateUrl: './approval-progress.component.html',
  styleUrls: ['./approval-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovalProgressComponent implements OnChanges {
  @Input() prdType;
  @Input() loader;
  status;

  // = {
  //   progressStatus: 'screening',
  //   progressPercentage: 50,
  // };
  constructor(private productService: PortalProductsService, private cdRef: ChangeDetectorRef) {}
  async ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['prdType'] && this.prdType) {
      try {
        this.status = await this.productService.getPrdSignupProgress(this.prdType);
        this.cdRef.detectChanges();
      } catch (e) {}
    }
    console.log('Product type changed:', this.prdType);
  }
}
